import { useEffect, useState } from "react";
import { Navigate } from "react-router";
import { ApiError, api } from "@/lib/api";
import {
  readRememberedAccountId,
  rememberAccountId,
  type WorkspaceAccount,
} from "@/lib/account-workspace";

export default function RootRedirectPage() {
  const [target, setTarget] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .fetch<{ accounts: WorkspaceAccount[] }>("/accounts")
      .then(({ accounts }) => {
        if (accounts.length === 0) {
          setTarget("/onboarding");
          return;
        }
        const remembered = readRememberedAccountId();
        const match =
          remembered && accounts.some((account) => String(account.id) === remembered)
            ? remembered
            : String(accounts[0].id);
        rememberAccountId(match);
        setTarget(`/accounts/${match}`);
      })
      .catch((caughtError) => {
        setError(caughtError instanceof ApiError ? caughtError.message : "无法进入工作台");
      });
  }, []);

  if (error) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
        <p
          className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive"
          role="alert"
        >
          {error}
        </p>
      </main>
    );
  }

  if (!target) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-muted/30 text-sm text-muted-foreground">
        正在进入账户工作台…
      </main>
    );
  }

  return <Navigate to={target} replace />;
}
